import "../jquery-ui";
import * as lazyframe from 'lazyframe';

lazyframe($('#youtube-intro'), {
  debounce: 250,
  lazyload: true,
  autoplay: true,
})
  
$(".player-button").on('click', function () {
  $(".thumbnail img").css('display', 'none');
  $(".player-button").css('display', 'none');
  $(".frame").css('display', 'block');
})